module.exports = __webpack_public_path__ + "static/development-ee3ed58883a79ff9985a78838ddce0ff.jpg";